export const EMAIL = 'javier00parra@gmail.com';
export const WHATSAPP_NUMBER = '+573133217887';
